import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { navLinks } from '../data/mock';

const NavItem = ({ link, onClick, className }) => {
  const isRoute = link.href.startsWith('/');
  return isRoute ? (
    <Link to={link.href} onClick={onClick} className={className}>{link.label}</Link>
  ) : (
    <a href={link.href} onClick={onClick} className={className}>{link.label}</a>
  );
};

const Logo = () => (
  <Link
    to="/"
    className="flex items-center gap-2 select-none"
    aria-label="FreeFitFuel home"
    data-testid="site-logo"
  >
    <span
      className="text-white font-black tracking-tight text-xl lg:text-2xl leading-none"
      style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
    >
      Free<span className="text-[#BEFF38]">Fit</span>Fuel
    </span>
  </Link>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-40 bg-[color:var(--fff-glass-bg)] backdrop-blur-xl border-b border-[color:var(--fff-glass-border)]"
      data-testid="site-header"
    >
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between py-3 lg:py-3.5">
          <Logo />
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-md text-zinc-300 hover:text-white hover:bg-white/5 transition-colors"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
          <nav className="hidden lg:flex items-center gap-x-1">
            {navLinks.map((l) => (
              <NavItem
                key={l.label}
                link={l}
                className="px-3 py-2 text-sm font-semibold text-zinc-300 rounded-md hover:text-white hover:bg-white/5 transition-colors"
              />
            ))}
            <Link
              to="/my-plan"
              data-testid="header-open-app-cta"
              className="ml-2 inline-flex items-center px-4 py-2 rounded-full bg-[#BEFF38] hover:bg-[#a8e62e] text-black font-black text-xs uppercase tracking-wider transition-colors"
            >
              Open app
            </Link>
          </nav>
        </div>
        {open && (
          <nav className="lg:hidden pb-3 grid grid-cols-2 gap-1" data-testid="mobile-menu">
            {navLinks.map((l) => (
              <NavItem
                key={l.label}
                link={l}
                onClick={() => setOpen(false)}
                className="px-3 py-2 text-sm font-semibold text-zinc-300 rounded-md hover:text-white hover:bg-white/5"
              />
            ))}
            <Link
              to="/my-plan"
              onClick={() => setOpen(false)}
              data-testid="mobile-open-app-cta"
              className="col-span-2 mt-1 inline-flex items-center justify-center px-4 py-2.5 rounded-full bg-[#BEFF38] text-black font-black text-xs uppercase tracking-wider"
            >
              Open app →
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
